<template>
  <div class="order-service-general-quotation-answer-forms">
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" label="Загрузка..."></b-spinner>
    </div>
    
    <div v-else>
      <!-- Заголовок -->
      <div class="mb-4">
        <h6>Ответы на котировку</h6>
        <!-- <p class="text-muted mb-0">
        </p> -->
      </div>

      <!-- Список ответов -->
      <div v-if="answers.length > 0">
        <div 
          v-for="(answer, index) in answers" 
          :key="answer.id"
          class="quotation-answer-card mb-4"
        >
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <div>
                <h6 class="mb-0">
                  Ответ на запрос
                  <!-- <span v-if="answer.user" class="text-muted">от {{ answer.user.name }}</span> -->
                </h6>
              </div>
              <div>
                <b-badge 
                  :variant="getStatusBadgeVariant(answer.status)"
                  class="ml-2"
                >
                  {{ getStatusText(answer.status) }}
                </b-badge>
              </div>
            </div>
            
            <div class="card-body">
              <!-- Форма редактирования для статуса "filling" -->
              <div v-if="!showDataOnly && answer.status === 'filling' && canEditAnswer(answer)">
                <b-form @submit.prevent="saveAnswer(answer, true)">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group label="Стоимость услуги">
                        <b-form-input
                          v-model.number="answer.delivery_cost"
                          type="number"
                          step="0.01"
                          placeholder="Введите стоимость"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group label="Валюта">
                        <b-form-select
                          v-model="answer.currency_id"
                          :options="currencyOptions"
                          required
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  
                  <b-row>
                    <b-col cols="6">
                      <b-form-group label="Срок выполнения (дни)">
                        <b-form-input
                          v-model="answer.transit_time"
                          type="text"
                          placeholder="7 дней"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group label="Валидность предложения">
                        <b-form-input
                          v-model="answer.validity_date"
                          type="date"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  
                  <b-form-group label="Комментарий">
                    <b-form-textarea
                      v-model="answer.comment"
                      rows="3"
                      placeholder="Дополнительная информация, условия, примечания..."
                    ></b-form-textarea>
                  </b-form-group>
                  
                  <div class="text-right">
                    <b-button 
                      type="button" 
                      variant="outline-primary"
                      :disabled="savingOnly || saving"
                      @click.stop.prevent="saveAnswerOnly(answer)"
                      class="mr-2"
                    >
                      <b-spinner small v-if="savingOnly"></b-spinner>
                      {{ savingOnly ? 'Сохранение...' : 'Сохранить' }}
                    </b-button>
                    <b-button 
                      type="submit" 
                      variant="primary"
                      :disabled="saving || savingOnly"
                    >
                      <b-spinner small v-if="saving"></b-spinner>
                      {{ saving ? 'Сохранение...' : 'Сохранить и отправить' }}
                    </b-button>
                  </div>
                </b-form>
              </div>
              
              <!-- Отображение данных для других статусов -->
              <div v-else>
                <b-row>
                  <b-col cols="6">
                    <strong>Стоимость:</strong>
                    <p class="mb-2">
                      {{ answer.delivery_cost ? `${answer.delivery_cost} ${getCurrencyText(answer.currency_id)}` : 'Не указана' }}
                    </p>
                  </b-col>
                  <b-col cols="6">
                    <strong>Срок выполнения:</strong>
                    <p class="mb-2">
                      {{ answer.transit_time ? `${answer.transit_time} дней` : 'Не указан' }}
                    </p>
                  </b-col>
                </b-row>
                
                <b-row>
                  <b-col cols="6">
                    <strong>Валидность:</strong>
                    <p class="mb-2">
                      {{ answer.validity_date ? formatDate(answer.validity_date) : 'Не указана' }}
                    </p>
                  </b-col>
                  <b-col cols="6">
                    <strong>Менеджер:</strong>
                    <p class="mb-2">
                      {{ answer.user ? answer.user.name : 'Не назначен' }}
                    </p>
                  </b-col>
                </b-row>
                
                <div v-if="answer.comment">
                  <strong>Комментарий:</strong>
                  <p class="mb-2">{{ answer.comment }}</p>
                </div>
                
                                 <!-- Поле для ставки клиента - показывается только для прокотированных ответов и агентов -->
                 <div 
                   v-if="(answer.status === 'sent' || answer.status === 'selected') && isAgent"
                   class="quotation-bill mt-3 p-3 bg-light border-left border-primary"
                 >
                   <h6 class="text-primary mb-3">Ставка для клиента</h6>
                   
                   <!-- Если ставка уже сохранена -->
                   <div 
                     v-if="answer.client_rate" 
                     class="mb-3"
                   >
                     <div class="row">
                       <div class="col-md-6">
                         <strong>Ставка для клиента:</strong> {{ answer.client_rate }} {{ getCurrencyText(answer.client_rate_currency) }}
                       </div>
                       <div class="col-md-12 mt-2" v-if="answer.client_rate_manager">
                         <small class="text-muted">
                           {{ answer.client_rate_manager.name }} / {{ formatDate(answer.client_rate_saved_at) }}
                         </small>
                       </div>
                     </div>
                   </div>

                   <!-- Поле для ввода/редактирования ставки клиента -->
                   <div class="row align-items-end" v-if="!showDataOnly">
                     <div class="col-sm-12 col-md-4">
                       <b-form-group 
                         label="Ставка для клиента" 
                         label-class="form-label-sm"
                         class="mb-2"
                       >
                         <b-form-input
                           v-model="clientRateForm[answer.id]"
                           type="number"
                           step="0.01"
                           min="0"
                           :placeholder="answer.client_rate || 'Введите ставку'"
                           :disabled="answer.status === 'selected'"
                           size="sm"
                         ></b-form-input>
                       </b-form-group>
                     </div>

                     <div class="col-sm-12 col-md-3 text-center">
                       <div class="w-100 lh14px pb-2 mb-1">
                         <small class="text-muted d-block">Маржинальность:</small>
                         <span class="font-weight-bold" :class="getMarginColor(answer.delivery_cost, clientRateForm[answer.id])">
                           {{ calculateMargin(answer.delivery_cost, clientRateForm[answer.id]) }}%
                         </span>
                       </div>
                     </div>

                     <div class="col-sm-12 col-md-4 pb-2 mb-1 text-left">
                        <b-button
                           type="button"
                           variant="outline-primary"
                           size="sm"
                           @click="saveClientRate(answer)"
                           :disabled="savingClientRate[answer.id] || answer.status === 'selected' || !clientRateForm[answer.id] || clientRateForm[answer.id] == answer.client_rate"
                         >
                            Сохранить ставку
                            <i class="fas fa-spinner fa-spin ml-1" v-if="savingClientRate[answer.id]"></i>
                            <i v-else class="fas fa-save ml-1"></i>
                       </b-button>
                     </div>
                   </div>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Сообщение если нет ответов -->
      <div v-else class="text-center py-4">
        <div class="alert alert-info">
          <i class="fas fa-info-circle mr-2"></i>
          Пока нет ответов на котировку. Менеджеры работают над предложениями.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { 
  API_ORDER_SERVICE_GENERAL_QUOTATION_ANSWERS,
  API_ORDER_SERVICE_GENERAL_QUOTATION_ANSWERS_SEND,
  API_ORDER_SERVICE_GENERAL_QUOTATION_ANSWERS_SELECT,
  API_ORDER_SERVICE_GENERAL_QUOTATION_ANSWERS_CLIENT_RATE
} from '@/constants';

export default {
  props: {
    orderId: { type: Number|String, required: true },
    orderServiceId: { type: Number|String, required: true },
    orderServiceQuotationId: { type: Number|String, required: true },
    orderReferenceStatusId: { type: Number|String, required: true },
    showDataOnly: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      saving: false,
      savingOnly: false, // для кнопки "Сохранить"
      answers: [],
      clientRateForm: {}, // { answerId: clientRate } для формы ставки клиента
      savingClientRate: {}, // { answerId: true/false } для кнопки "Сохранить ставку"
      currencyOptions: [
        { value: 'RUB', text: 'RUB' },
        { value: 'USD', text: 'USD' },
        { value: 'EUR', text: 'EUR' },
        { value: 'CNY', text: 'CNY' }
      ]
    };
  },
  computed: {
    ...mapGetters("auth", ["currentUser"]),
    
    isAgent() {
      return this.currentUser.role.includes('agent');
    },
    
    isManager() {
      return this.currentUser.role.includes('manager') || 
             this.currentUser.role.includes('head-manager') ||
             this.currentUser.role.includes('TO-head-manager');
    }
  },
  mounted() {
    this.loadAnswers();
  },
  methods: {
    async loadAnswers() {
      this.loading = true;
             try {
         const { data } = await api.call('get', `${API_ORDER_SERVICE_GENERAL_QUOTATION_ANSWERS}`, {
           params: {
             order_id: this.orderId,
             order_service_id: this.orderServiceId,
             order_service_quotation_id: this.orderServiceQuotationId
           }
         });
        
                 this.answers = data.data || [];
         
         // Инициализируем формы для ставок клиентов
         this.answers.forEach(answer => {
           if (answer.client_rate && !this.clientRateForm[answer.id]) {
             this.$set(this.clientRateForm, answer.id, answer.client_rate);
           }
         });
      } catch (error) {
        console.error('Ошибка при загрузке ответов:', error);
        this.$bvToast.toast('Ошибка при загрузке ответов на котировку', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.loading = false;
      }
    },
    
    canEditAnswer(answer) {
      // Менеджер может редактировать только свои ответы в статусе "filling"
      return !this.isAgent && 
             (this.orderReferenceStatusId === 541 || answer.status === 'filling');
    },
    
    async saveAnswer(answer, sendToQuotation = false) {
      if (sendToQuotation) {
        this.saving = true;
      } else {
        this.savingOnly = true;
      }
      
      try {
        const payload = {
          delivery_cost: answer.delivery_cost,
          currency_id: answer.currency_id,
          transit_time: answer.transit_time,
          validity_date: answer.validity_date,
          comment: answer.comment
        };
        
        let apiUrl, successMessage, updateMessage;
        
        if (sendToQuotation) {
          apiUrl = `${API_ORDER_SERVICE_GENERAL_QUOTATION_ANSWERS_SEND}/${answer.id}/send`;
          successMessage = 'Ответ успешно сохранен и отправлен';
          updateMessage = 'Ответ на котировку обновлен';
        } else {
          apiUrl = `${API_ORDER_SERVICE_GENERAL_QUOTATION_ANSWERS}/${answer.id}`;
          successMessage = 'Ответ успешно сохранен';
          updateMessage = 'Ответ на котировку сохранен';
        }
        
        const httpMethod = sendToQuotation ? 'post' : 'put';
        await api.call(httpMethod, apiUrl, payload);
        
        this.$bvToast.toast(successMessage, {
          title: 'Успех',
          variant: 'success',
          solid: true
        });
        
        // Перезагружаем ответы
        await this.loadAnswers();
        
        // Уведомляем родительский компонент
        this.$emit('orderUpdated', {
          orderId: this.orderId,
          message: updateMessage
        });
        
      } catch (error) {
        console.error('Ошибка при сохранении ответа:', error);
        this.$bvToast.toast('Ошибка при сохранении ответа', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
      } finally {
        if (sendToQuotation) {
          this.saving = false;
        } else {
          this.savingOnly = false;
        }
      }
    },
    
    async saveAnswerOnly(answer) {
      return this.saveAnswer(answer, false);
    },
    
    async saveClientRate(answer) {
       this.savingClientRate[answer.id] = true;

       try {
         const payload = {
           id: answer.id,
           client_rate: this.clientRateForm[answer.id],
           client_rate_currency: answer.currency_id
         };
         
         await api.call('post', `${API_ORDER_SERVICE_GENERAL_QUOTATION_ANSWERS_CLIENT_RATE}/${answer.id}/client-rate`, payload);
         
         this.$bvToast.toast('Ставка для клиента сохранена', {
           title: 'Успех',
           variant: 'success',
           solid: true
         });
         
         // Очищаем форму для этого ответа
         this.$delete(this.clientRateForm, answer.id);
       } catch (error) {
            this.savingClientRate[answer.id] = false;
            console.error('Ошибка при сохранении ставки для клиента:', error);
            this.$bvToast.toast('Ошибка при сохранении ставки для клиента', {
                title: 'Ошибка',
                variant: 'danger',
                solid: true
            });
       } finally {
            this.savingClientRate[answer.id] = false;

            // Перезагружаем ответы
            await this.loadAnswers();
            
            // Уведомляем родительский компонент
            this.$emit('orderUpdated', {
                orderId: this.orderId,
                message: 'Ставка для клиента обновлена'
            });
       }
     },
    
    getStatusBadgeVariant(status) {
      const variants = {
        'filling': 'warning',
        'sent': 'info',
        'selected': 'success',
        'rejected': 'danger'
      };
      return variants[status] || 'secondary';
    },
    
    getStatusText(status) {
      const texts = {
        'filling': 'Заполняется',
        'sent': 'Оценено',
        'selected': 'Выбрано',
        'rejected': 'Отклонено'
      };
      return texts[status] || status;
    },
    
    getCurrencyText(currencyId) {
      const currency = this.currencyOptions.find(c => c.value === currencyId);
      return currency ? currency.text : currencyId;
    },
    
         formatDate(date) {
       if (!date) return '';
       return new Date(date).toLocaleDateString('ru-RU');
     },
     
     // Расчет маржинальности
     calculateMargin(cost, clientRate) {
       if (!cost || !clientRate || cost <= 0 || clientRate <= 0) return 0;
       return Math.round(((clientRate - cost) / cost) * 100);
     },
     
     // Получение цвета для маржинальности
     getMarginColor(cost, clientRate) {
       const margin = this.calculateMargin(cost, clientRate);
       if (margin < 0) return 'text-danger';
       if (margin < 10) return 'text-warning-dark';
       return 'text-success';
     }
   }
 };
</script>

<style scoped>
.order-service-general-quotation-answer-forms {
  margin-top: 2rem;
}

.quotation-answer-card {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}
</style>
